module.exports = __webpack_public_path__ + "assets/img/F1.e72d6e17.png";